import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Lead } from 'models/Lead';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { getUserFullName } from 'utils';

import './LeadsField.styles.scss';

type LeadsFieldProps = {
  className?: string;
  leads: Array<Partial<Lead>>;
};

const LeadsField: React.FC<LeadsFieldProps> = (props) => {
  const { className, leads } = props;

  const classes = classNames('leads-field', className);

  const { values } = useFormState();

  const { change, batch } = useForm();

  const { t } = useTranslation();

  const handleIsExternalLead = useCallback(() => {
    batch(() => {
      change('isExternalUnderOfferLead', true);
      change('underOfferLeadId', null);
    });
  }, [batch, change]);

  const handleLead = useCallback(
    (id) => {
      batch(() => {
        change('isExternalUnderOfferLead', false);
        change('underOfferLeadId', id);
      });
    },
    [batch, change],
  );

  return (
    <div className={classes}>
      <div className="leads-field-wrapper">
        {!leads.length ? (
          <p>{t('leadFieldEmptyState')}</p>
        ) : (
          leads.map(({ _id, email, firstName, lastName }) => (
            <div
              key={_id}
              onClick={() => handleLead(_id)}
              className={classNames('leads-field__card', {
                checked: values['underOfferLeadId'] === _id,
              })}
            >
              <p>
                {`${getUserFullName(firstName, lastName)} - `}
                <span>{email || t('na')}</span>
              </p>
            </div>
          ))
        )}
      </div>

      <div
        className={classNames('leads-field__card', {
          checked: values['isExternalUnderOfferLead'],
        })}
        onClick={handleIsExternalLead}
      >
        {t('leadDidntComeFromResolve')}
      </div>
    </div>
  );
};

export default LeadsField;
